import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Allies from './Allies';
import BannerAllies from './BannerAllies';
import Banner from './Banner';
import Layout from '../layout/Layout';
import HomeBanner from './homeBanners/HomeBanner';

export default function HomePage() {
  return (
    <Layout lowMargin>
      <ErrorBoundary
        fallbackRender={() => <h1>Hubo un error en el Banner1</h1>}
      >
        <Banner />
      </ErrorBoundary>
      <ErrorBoundary
        fallbackRender={() => <h1>Hubo un error en el HomeBanner1</h1>}
      >
        <HomeBanner
          bannerName="medio1"
          srcItem={1}
          fallbackSrc="apps/client/components/home/BannerImage.tsx"
        />
      </ErrorBoundary>
      <ErrorBoundary fallbackRender={() => <h1>Hubo un error en el Allies</h1>}>
        <Allies />
      </ErrorBoundary>
      <ErrorBoundary
        fallbackRender={() => <h1>Hubo un error en el HomeBanner2</h1>}
      >
        <HomeBanner
          bannerName="medio2"
          srcItem={2}
          fallbackSrc="/images/meitBoxesColor.png"
        />
      </ErrorBoundary>
      <ErrorBoundary
        fallbackRender={() => <h1>Hubo un error en el BannerAllies</h1>}
      >
        <BannerAllies />
      </ErrorBoundary>
    </Layout>
  );
}
